import { COMMENT_MIN_LENGTH, EMAIL_MAX_LENGTH } from '../../constants/shared';
export const SHARED_TRANSLATION = {
    'FORM.VALIDATION.INVALID_EMAIL_FORMAT': 'Adresa de e-mail este invalidă',
    'FORM.VALIDATION.EMAIL_IN_INTERVAL': `Adresa de e-mail nu poate conține mai mult de ${EMAIL_MAX_LENGTH} caractere`,
    'TEXTAREA.REMAINING_CHARACTERS': '{{remainingCharactersCount}} caractere rămase',
    'PAGINATION.ELEMENTS_PER_PAGE': 'elemente / pagină',
    'PAGINATION.NUMBER_OF_ELEMENTS': '{{start}}-{{end}} din {{totalRecords}} elemente',
    'PAGINATION.ALL_ELEMENTS': 'Toate',
    'TABLE.NO_ELEMENT_FOUND': 'Niciun element găsit',
    'TABLE.ACTIONS.FILTER': 'Filtrează',
    'TABLE.ACTIONS.EXPORT': 'Exportă',
    'TABLE.ACTIONS.COLUMNS': 'Coloane',
    'CANCEL': 'Anulează',
    'RESET': 'Resetează',
    'FILTER': 'Filtrează',
    'CONFIRM': 'Confirmă',
    'SAVE': 'Salvează',
    'YES': 'Da',
    'NO': 'Nu',
    'TRY_AGAIN': 'Încearcă din nou',
    'ACTIVE_MALE_PLURAL': 'Activi',
    'ACTIVE_FEMALE_PLURAL': 'Active',
    'MAXIMUM': 'Maxim',
    'COMMENT': 'Comentează',
    'DISCONNECT': 'Deconectează',
    'USER.STATUS.ACTIVE': 'Activ',
    'USER.STATUS.INACTIVE': 'Inactiv',
    'CLIENT.STATUS.ACTIVE': 'Activ',
    'CLIENT.STATUS.INACTIVE': 'Inactiv acces',
    'CLIENT.STATUS.READ_ONLY': 'Inactiv operații',
    'CLIENT.STATUS.DELETED': 'Șters',
    'CLIENT.ROLES.UNIVERSAL': 'Universal',
    'CLIENT.ROLES.CREATOR': 'Creator',
    'CLIENT.ROLES.CREATOR_AND_APPROVER': 'Creator & Aprobator',
    'CLIENT.ROLES.VERIFIER': 'Verificator',
    'CLIENT.ROLES.WATCHER': 'Privitor',
    'COMPANY.ROLES.UNIVERSAL': 'Universal',
    'COMPANY.ROLES.NONUNIVERSAL': 'Creator, (Verificator), Aprobator',
    'ROLE.KPMG_ADMIN': 'Admin KPMG',
    'ROLE.KPMG_CLIENT': 'Client KPMG',
    'ROLE.UNIVERSAL': 'Universal',
    'ROLE.CREATOR': 'Creator',
    'ROLE.VERIFIER': 'Verificator',
    'ROLE.APPROVER': 'Aprobator',
    'ROLE.WATCHER': 'Privitor',
    'ROLE.CATEGORY.CONTRIBUTOR': 'Contributoare',
    'ROLE.CATEGORY.INSPECTOR': 'Inspectoare',
    'COMPANY.STATUS.ACTIVE': 'Activă',
    'COMPANY.STATUS.INACTIVE': 'Inactivă',
    'COMPANY.STATUS.READ_ONLY': 'Inactivă operații',
    'TAX.TYPE.103': '103 Impozit pe profit (datorat de persoane juridice române)',
    'TAX.TYPE.102': '102 Impozit pe profit (datorat de bănci comerciale)',
    'TAX.TYPE.105': '105 Impozit pe profit (datorat de persoane juridice străine)',
    'FISCAL_YEAR.TYPE.CALENDAR': 'Calendaristic',
    'CALCULATION.QUARTER1': 'Trim 1 (ian-mar)',
    'CALCULATION.QUARTER2': 'Trim 2 (ian-iun)',
    'CALCULATION.QUARTER3': 'Trim 3 (ian-sep)',
    'CALCULATION.QUARTER4': 'Anual (ian-dec)',
    'BALANCE.ACCOUNT.STATUS.NEW': 'Nou',
    'BALANCE.ACCOUNT.STATUS.UNCHANGED': 'Neschimbat',
    'BALANCE.ACCOUNT.STATUS.REMOVED': 'Eliminat',
    'BALANCE.ACCOUNT.USAGE.STATUS.USED': 'Utilizat',
    'BALANCE.ACCOUNT.USAGE.STATUS.UNUSED': 'Neutilizat',
    'CALCULATION.STATUS.APPROVED': 'Aprobat',
    'CALCULATION.STATUS.APPROVED_DRAFT': 'Aprobat Draft',
    'CALCULATION.STATUS.DRAFT_APPROVER': 'Draft A',
    'CALCULATION.STATUS.DRAFT_CREATOR': 'Draft C',
    'CALCULATION.STATUS.DRAFT_VERIFIER': 'Draft V',
    'CALCULATION.STATUS.DRAFT_UNIVERSAL': 'Draft U',
    'CALCULATION.STATUS.REJECTED_CREATOR': 'Respins C',
    'CALCULATION.STATUS.REJECTED_CREATOR_AND_VERIFIER': 'Respins C&V',
    'CALCULATION.STATUS.REOPENED': 'Redeschis',
    'CALCULATION.STATUS.TO_BE_APPROVED': 'De Aprobat',
    'CALCULATION.STATUS.TO_BE_REOPENED': 'Redeschidere',
    'CALCULATION.STATUS.TO_BE_SUBMITTED': 'Pentru Depunere',
    'CALCULATION.STATUS.TO_BE_VERIFIED': 'De Verificat',
    'CALCULATION.STATUS.NEW': 'Nou',
    'TOTAL': 'Total',
    'ACTIONS': 'Acțiuni',
    'DOCUMENT.TYPE.ATTACHMENT': 'Atașament',
    'DOCUMENT.TYPE.SUBMISSION_RECORD': 'Recipisă',
    'CALCULATION_SUBMISSION.TYPE.WITH_RECEIPT': 'Cu Recipisă',
    'CALCULATION_SUBMISSION.TYPE.WITHOUT_RECEIPT': 'Fără Recipisă',
    'CALCULATION_STATEMENT.TYPE.INITIAL': 'Inițială',
    'CALCULATION_STATEMENT.TYPE.RECTIFICATION': 'Rectificativă {{statementIndex}}',
    'CALCULATION_STATEMENT.STATUS.DRAFT': 'Draft',
    'CALCULATION_STATEMENT.STATUS.SUBMITTED': 'Depusă',
    'CALCULATION_STATEMENT.STATUS.NOT_SUBMITTED': 'Nedepusă',
    'CALCULATION_RECEIPT.STATUS.NOT_AVAILABLE': 'N/A',
    'CALCULATION_RECEIPT.STATUS.RECEIVED': 'Primită',
    'CALCULATION_RECEIPT.STATUS.NOT_RECEIVED': 'Neprimită',
    'IDLE_USER.MODAL.TITLE': 'Continui utilizarea?',
    'IDLE_USER.MODAL.SUBTITLE1': 'Am înregistrat o periodă îndelungată de inactivitate și din motive de siguranță va avea loc o deconectare automată în timpul indicat mai sus.',
    'IDLE_USER.MODAL.SUBTITLE2': 'Deconectarea automată presupune că:',
    'IDLE_USER.MODAL.CONSEQUENCE2_1': 'informația din afara calculelor, introdusă in această sesiune și care nu a fost salvată, va fi pierdută',
    'IDLE_USER.MODAL.CONSEQUENCE2_2': 'informația introdusă în calcul, exclusiv în pasul de calculație la care apare deconectarea, va fi pierdută',
    'LOGOUT_CONFIRM.MODAL.TITLE': 'Ești sigur că vrei să te deconectezi?',
    'DOCUMENTS.ACCEPTED_EXTENSIONS': 'Extensie acceptată: \n\r- \'doc\', \'docx\', \'pdf\', \'odt\',\n\r- \'rtf\', \'txt\', \'xml\', \'xps\', \'csv\',\n\r- \'ods\', \'xls\', \'xlsx\', \'xlsb\', \'xlw\',\n\r- \'bmp\', \'gif\', \'jpg\', \'odp\', \'png\',\n\r- \'ppt\', \'pptx\', \'pps\', \'ppsx\', \'tif\',\n\r- \'mp4\', \'avi\', \'mpeg\', \'mpg\'',
    'DOCUMENTS.INCORRECT_FORMAT': '{{invalidDocumentsNumber}} document(e) nu s-a(u) încărcat datorită extensiei neacceptate',
    'REASON.COMMENT.LABEL': 'Introduceți motivul (obligatoriu):',
    'REASON.COMMENT.PLACEHOLDER': 'Introduceți motivul justificării (min 20 - max 500 caractere)',
    'REASON.VALIDATION.COMMENT_MIN_VALUE': `Motivul introdus trebuie să conțină minim ${COMMENT_MIN_LENGTH} de caractere`,
    'OK': 'Ok'
};
